import { coreInstance, globalAxios, backendVersion, utilsAxios } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    rider_wallet: [],
    rider_wallet_inactive: [],
    rider_wallet_deleted: [],
    rider_wallet_transaction: [],
    cash_request: [],
    refill_credit_list: [],
    free_price_per_round: []
  },
  mutations: {
    resetState(state) {
      state.cash_request = [];
      state.rider_wallet = [];
      state.rider_wallet_transaction = [];
      state.refill_credit_list = [];
      state.free_price_per_round = [];
      state.rider_wallet_inactive = [];
      state.rider_wallet_deleted = [];
    },
    getCashReqest(state, data) {
      state.cash_request = data;
    },
    getRiderWallet(state, data) {
      state.rider_wallet = data.filter(val => val.wallet_user_status == 'active');
      state.rider_wallet_inactive = data.filter(val => val.wallet_user_status == 'inactive');
      state.rider_wallet_deleted = data.filter(val => val.wallet_user_status == 'delete');
    },
    getRiderTransaction(state, data) {
      state.rider_wallet_transaction = data;
    },
    getRefillCredit(state, data) {
      state.refill_credit_list = data;
    },
    getFreePricePerRound(state, data) {
      state.free_price_per_round = data;
    }
  },
  actions: {
    async saveFreePricePerRound(
      { commit, rootState, dispatch },
      form
    ) {
      let url = rootState.api_urls.fetchCashRider_saveFreePricePerRound;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getFreePricePerRound", res);
        return true;
      }
    },
    async getFreePricePerRound({ commit, rootState, dispatch }) {
      let url = rootState.api_urls.fetchCashRider_getFreePricePerRound;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getFreePricePerRound", res);
        return res;
      }
    },
    async getRefillCredit({ commit, rootState, dispatch }) {
      let url = rootState.api_urls.fetchCashRider_RefillCredit;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getRefillCredit", res);
        return true;
      }
    },
    async getCashReqest({ commit, state, dispatch }) {
      let url = backendVersion.version + "/Office/RequesCash";

      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getCashReqest", res);
      }
    },
    async approveCashReqest({ commit, state, dispatch }, id) {
      let url = backendVersion.version + "/Office/RequesCash/" + id;

      let res = await dispatch(
        "fetchGeneral/coreInstancePostData",
        { url, form: {} },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return res;
      }
    },
    async rejectCashReqest({ commit, state, dispatch }, id) {
      let url = backendVersion.version + "/Office/RequesCash/" + id;
      let res = await dispatch("fetchGeneral/coreInstanceDeleteData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },

    async getRiderWallet({ commit, rootState, dispatch }) {
      let url = rootState.api_urls.fetchCashRider_getRiderWallet;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("getRiderWallet", res);
        return res;
      }
    },

    async getRiderTransaction(
      { commit, state, }, { province, rider_id }
    ) {
      state.rider_wallet_transaction = [];
      let url = `/api/v1/${province}/Office/RiderWallet/${rider_id}`;
      return globalAxios
        .get(url)
        .then((res) => {
          commit("getRiderTransaction", res);
          return true;
        })
        .catch((error) => false);


    },
    async RefillCredit({ commit, rootState, dispatch }, refillData) {
      let url = rootState.api_urls.fetchCashRider_RefillCredit;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: refillData },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async postWithdrawCash({ commit, rootState, dispatch }, withdrawData) {
      let url = rootState.api_urls.fetchCashRider_postWithdrawCash;

      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form: withdrawData },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    fetchRequestCashLog({ }, {
      page_size,
      current_page,
    }) {
      let url = `/api/v1/get/log_money_transection?page_size=${page_size}&current_page=${current_page}`;
      return globalAxios
        .get(url)
        .then((res) => {
          if (res.msg === false) return [];
          return res.data;
        })
        .catch((error) => []);
    }
    ,

    // Auto transfer state helpers (moved from component)
    async getAutoTransferState({ dispatch }) {
      try {
        const url = "/api/v1/auto_transfer_state";
        const res = await utilsAxios.get(url);
        // parse likely shapes: boolean or { data: { state: x } } or { state: x }
        if (res == null) return false;
        if (typeof res === "boolean") return res;
        if (typeof res === "object") {
          if (res.data !== undefined) {
            if (typeof res.data === "object") {
              return (
                (res.data.state !== undefined && res.data.state !== null)
                  ? res.data.state
                  : (res.data.auto_transfer_state !== undefined && res.data.auto_transfer_state !== null)
                    ? res.data.auto_transfer_state
                    : (res.data.enabled !== undefined && res.data.enabled !== null)
                      ? res.data.enabled
                      : false
              );
            }
            return res.data;
          }
          return (
            (res.state !== undefined && res.state !== null)
              ? res.state
              : (res.auto_transfer_state !== undefined && res.auto_transfer_state !== null)
                ? res.auto_transfer_state
                : (res.enabled !== undefined && res.enabled !== null)
                  ? res.enabled
                  : false
          );
        }
        return false;
      } catch (err) {
        dispatch("disconnectNetwork", err, { root: true });
        return false;
      }
    },

    async setAutoTransferState({ dispatch }, enabled) {
      try {
        const url = "/api/v1/auto_transfer_state";
        const payload = { state: enabled ? 1 : 0 };
        const res = await utilsAxios.put(url, payload);
        // return parsed state or true/false
        if (res == null) return false;
        if (typeof res === "boolean") return res;
        if (typeof res === "object") {
          if (res.data !== undefined) {
            if (typeof res.data === "object") {
              return (
                (res.data.state !== undefined && res.data.state !== null)
                  ? res.data.state
                  : (res.data.auto_transfer_state !== undefined && res.data.auto_transfer_state !== null)
                    ? res.data.auto_transfer_state
                    : (res.data.enabled !== undefined && res.data.enabled !== null)
                      ? res.data.enabled
                      : true
              );
            }
            return res.data;
          }
          return true;
        }
        return true;
      } catch (err) {
        dispatch("disconnectNetwork", err, { root: true });
        return false;
      }
    }
  },
  getters: {
    getFreePricePerRoundList(state) {
      let clone_json = JSON.parse(JSON.stringify(state.free_price_per_round));
      clone_json.sort(function (a, b) {
        let nameA = a.round_id;
        if (typeof nameA == "string") {
          if (!parseFloat(nameA)) {
            nameA = nameA.toUpperCase();
          } else {
            nameA = parseFloat(nameA);
          }
        }
        let nameB = b.round_id;
        if (typeof nameB == "string") {
          if (!parseFloat(nameB)) {
            nameB = nameB.toUpperCase();
          } else {
            nameB = parseFloat(nameB);
          }
        }
        if (nameA === nameB) {
          return 0;
        } else if (nameA === null) {
          return 1;
        } else if (nameB === null) {
          return -1;
        } else if (false) {
          return nameA < nameB ? -1 : 1;
        } else {
          return nameA < nameB ? 1 : -1;
        }
      });
      for (let index in clone_json) {
        clone_json[index].no = parseInt(index) + 1;
      }
      return clone_json;
    },
    getRequestCashTable(state) {
      let cash_request_list = JSON.parse(JSON.stringify(state.cash_request));
      cash_request_list.sort(function (a, b) {
        let nameA = a.mt_id;
        if (typeof nameA == "string") {
          if (!parseFloat(nameA)) {
            nameA = nameA.toUpperCase();
          } else {
            nameA = parseFloat(nameA);
          }
        }
        let nameB = b.mt_id;
        if (typeof nameB == "string") {
          if (!parseFloat(nameB)) {
            nameB = nameB.toUpperCase();
          } else {
            nameB = parseFloat(nameB);
          }
        }
        if (nameA === nameB) {
          return 0;
        } else if (nameA === null) {
          return 1;
        } else if (nameB === null) {
          return -1;
        } else if (false) {
          return nameA < nameB ? -1 : 1;
        } else {
          return nameA < nameB ? 1 : -1;
        }
      });
      cash_request_list.sort(function (a, b) {
        let nameA = a.mt_approve;
        if (typeof nameA == "string") {
          if (!parseFloat(nameA)) {
            nameA = nameA.toUpperCase();
          } else {
            nameA = parseFloat(nameA);
          }
        }
        let nameB = b.mt_approve;
        if (typeof nameB == "string") {
          if (!parseFloat(nameB)) {
            nameB = nameB.toUpperCase();
          } else {
            nameB = parseFloat(nameB);
          }
        }
        if (nameA === nameB) {
          return 0;
        } else if (nameA === null) {
          return 1;
        } else if (nameB === null) {
          return -1;
        } else if (true) {
          return nameA < nameB ? -1 : 1;
        } else {
          return nameA < nameB ? 1 : -1;
        }
      });
      return cash_request_list;
    }
  }
};
